import { GateWay } from "./GateWay";

class PhienHopsGWndpoint extends GateWay {
  constructor() {
    super("/PhienHops");
  }
  addKhachMoi = (data) => this.PostAuthen("/KhachMoi", data);
  getQR = (id) =>
    this.GetAuthen(`/QRGeneration?PhienHopId=${id}`, { responseType: "text" });
}
export default new PhienHopsGWndpoint();
